export { useMediaQuery } from '@mui/material'

export const mdQuery = '(min-width: 720px)'
export const belowMdQuery = '(max-width: 767.98px)'
export const belowMdHeightQuery = '(max-height: 767.98px)'
export const aboveMdQuery = '(min-width: 768px)'
export const belowSmQuery = '(max-width: 575.98px)'
export const landscapeBelowSmQuery = `${belowMdQuery} and (orientation: landscape)`
export const landscapeAboveMdQuery = `${aboveMdQuery} and (orientation: landscape)`

export const belowMdWidthQueryPortrait = '(max-width: 767.98px) and (orientation: portrait)'
export const belowMdHeightQueryLandscape = '(max-height: 767.98px) and (orientation: landscape)'
